import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../Staff/Manage/Tooltip';

import { Arrow, TooltipItem, TooltipContent, TooltipContainer } from './styles';

interface IProps {
  sorted?: Boolean;
  onSort?: Function;
}

export function TooltipSortArrow({
  sorted = false,
  onSort = () => {},
}: IProps) {
  const { t: translate } = useTranslation();
  return (
    <TooltipContainer onClick={() => onSort(!sorted)}>
      <Tooltip
        text={<Arrow sorted={sorted} />}
        contentPopUp={
          <TooltipContent>
            <TooltipItem sorted={!sorted}>{translate('SORT.ASC')}</TooltipItem>
            <TooltipItem sorted={sorted}>{translate('SORT.DESC')}</TooltipItem>
          </TooltipContent>
        }
      />
    </TooltipContainer>
  );
}
